<template>
  <el-option :label="label" :value="value">
    <div class="label">{{ label }}</div>
    <el-tag class="tag" :type="tag.type" size="small" v-if="tag">
      {{ tag.text }}
    </el-tag>
    <div
      class="description"
      v-if="description"
      :style="{ color: descriptionColor }"
    >
      {{ description }}
    </div>
  </el-option>
</template>

<script>
export default {
  name: 'SelectOption',

  props: {
    label: {
      required: true
    },

    value: {
      required: true
    },

    tag: {
      required: false
    },

    description: {
      required: false
    },

    descriptionColor: {
      required: false
    }
  }
}
</script>

<style scoped>
.label {
  float: left;
}

.tag {
  float: left;
  margin-left: 6px;
  display: inline-block;
  margin-top: 6px;
}

.description {
  float: right;
  color: #8492a6;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/SelectOption.vue